export const MAXIMUM_RECEIPT_SIZE_IN_MB = 2;
export const MAXIMUM_BULK_DISPUTE_ZIP_SIZE_IN_MB = 800;
export const API_REQUEST_PAGE_SIZE = 10;
export const SYSTEM_ACCEPTED = "SYSTEM_ACCEPTED";
export const DECLINED = "DECLINED";
export const BACKOFFICE_CONFIGS = {
  DISPUTE_REASON_LIST: "dd.dispute.reason.list",
  GL_ACCOUNT_NUMBER_SIZE: "dd.gl.account.number.size",
  GL_NAME_ENQUIRY_OPTION: "dd.gl.name.enquiry.applicable",
  BACKOFFICE_DISPUTE_RESPONSE_CODES: "dd.dispute.backoffice.response-codes",
  FRONTOFFICE_DISPUTE_RESPONSE_CODES: "dd.dispute.merchant.response-codes",
  TRANSACTIONS_DOWNLOAD_DATE_RANGE: "dd.calendar.date-range-in-days",
  ACTIVE_DIRECTORY_STATUS: "dd.active-directory-enabled",
  AUTO_DISPUTE_CREATION_STATUS: "dd.recon.dispute.auto-create",
  VAT_RATE: "dd.charge.vat.percentage",
  IS_NAME_ENQUIRY_ENABLED: "dd.name-enquiry-enabled",
  IS_MANUAL_DISPUTE_REFUND_ENABLED: "dd.enable.manual.dispute-refund",
  IS_MANUAL_SETTLEMENT_PAYMENT_ENABLED: "dd.enable.manual.settlement-payment",
};
export const API_VERSION = "v1";
export const PASSWORD_VALIDATION_ERROR_MESSAGE =
  "Your password must be at least 12 characters long and include an uppercase letter, a lowercase letter, a number, and one of the following special characters: @, £, %, ^, or &.";
export const FAILED = "FAILED";
export const SUCCESSFUL = "SUCCESSFUL";
export const PENDING = "PENDING";
export const TAT_EXPIRED = "TAT_EXPIRED";
export const RESOLVED = "RESOLVED";
export const ACTIVATED = "ACTIVATED";
export const UserTypes = {
  Frontoffice: "Frontoffice",
  Backoffice: "Backoffice",
};
export const ACCOUNT_WEB = "account-web";
export const FRONT_OFFICE = "front-office";
export const BACK_OFFICE = "back-office";
export const SUPERAGENT_DISPUTES = "SUPERAGENT_DISPUTES";
export const BANK_DISPUTES = "BANK_DISPUTES";
export const ACCOUNT_TYPES = ["GL", "NUBAN"];
export const DisputeTypes = {
  Frontoffice: {
    BankDisputes: "BankDisputes",
    PaymentFacilitatorDisputes: "PaymentFacilitatorDisputes",
  },
  Backoffice: {
    BankDisputes: "BankDisputes",
    PaymentFacilitatorDisputes: "PaymentFacilitatorDisputes",
  },
};
export const ManualPaymentTypes = {
  Settlement: "Settlement",
  Dispute: "Dispute",
};
export const PAYMENT_FACILITATOR = "PAYMENT_FACILITATOR";
export const BANK = "BANK";
export const DOWNLOADED_FOR_PROCESSING = "DOWNLOADED_FOR_PROCESSING";
export const GLOBAL_MANDATE_DURATION_DAYS_WARNING_MESSAGE = `Setting maximum allowed duration to be less than 365 days will prevent mandate creation requests that have a duration of more than 365 days to be created. kindly confirm that you want to continue.`;
